import {
  TM_ORG_ROLES,
  TM_ADMIN_ROLE,
  TM_TEAM_ADMIN_ROLE,
  TM_TEAM_LIMIT_VALUE_FEATURE_DISABLED,
} from '@saucelabs/sl-util-config';
import { List } from 'immutable';

export function serializeFilters(filters) {
  const roles = filters.get('roles');
  const teams = filters.get('teams');
  const status = filters.get('status');
  const phrase = filters.get('phrase');

  return Object.assign(
    {},
    roles && roles.size && { roles: roles.join(',') },
    teams && teams.size && { teams: teams.join(',') },
    status && status.size && { status: status.join(',') },
    phrase && phrase.length && { phrase },
  );
}

export function updateFilter(filters, value) {
  if (List.isList(filters)) {
    const index = filters.indexOf(value);
    return index > -1 ? filters.delete(index) : filters.push(value);
  }

  return value;
}

/*
                      team_limit
                     1   +  many
                 +----------------
                  |      |       |      FT - free trial
                 1| FT,S | FT,S  |      S - subscribed
                  |      |  R    |      * - rest (invoiced, admins)
   limit_reached +---------------+
                  |      |       |      Features:
                 0| *    | *     |      - CT - create team
                  | CT,R | CT, R |      - R - admin role, showing teams tab
                 +----------------

  result:
  CT = ~limit_reached
  R = ~limit_reached v team_limit!=1
*/

export const allowToCreateNewTeams = (settings) => (
  !settings.team_limit_reached
);

export const teamFeatureEnabled = (settings) => (
  allowToCreateNewTeams(settings) ||
  settings.team_limit !== TM_TEAM_LIMIT_VALUE_FEATURE_DISABLED
);

export const groupsFeatureEnabled = (settings) => (
  settings.groups_enabled
);

export function filteredOrgRoles({ me }) {
  const allowTeamAdminRole = teamFeatureEnabled(me.organization.settings);
  return TM_ORG_ROLES.filter((role) => {
    // org admin role
    if (role.role === TM_ADMIN_ROLE) {
      return me.isOrgAdmin();
    }

    // team admin role
    if (role.role === TM_TEAM_ADMIN_ROLE) {
      return allowTeamAdminRole;
    }

    return true;
  });
}

export default {
  serializeFilters,
  updateFilter,
};
